import _extends from "@babel/runtime/helpers/extends";
export const stopOuterScroll = (event, startY = 0) => {
  const {
    currentTarget: target
  } = event;
  // eslint-disable-next-line compat/compat
  const touches = window.TouchEvent && event instanceof TouchEvent ? event.touches : undefined;
  let deltaY = event instanceof WheelEvent ? event.deltaY : 0;
  if (touches) {
    const currentY = touches[0].clientY;
    deltaY = startY - currentY;
  }

  // если происходит скролл на величину большую расстояния на границы блока,
  // то явно скроллим к границе, чтобы предотвратить скролл внешнего контейнера
  if (deltaY < 0) {
    if (target.scrollTop < -deltaY) {
      target.scrollTop = 0;
      event.preventDefault();
    }
  } else {
    const maxScroll = target.scrollHeight - target.offsetHeight;
    if (maxScroll - target.scrollTop < deltaY) {
      target.scrollTop = maxScroll;
      event.preventDefault();
    }
  }
};

// на маке scrollbarWidth = 0, но чтобы визуально скрыть скроллбар используем сдвиг на константу
export const SCROLLBAR_OFFSET = 20;
export const hideScrollStyles = (vertical, horizontal, scrollbarWidth) => {
  if (typeof scrollbarWidth !== 'number') {
    return undefined;
  }

  // скролл "виртуальный" когда его ширина 0 (как на маке).
  const virtualScroll = scrollbarWidth === 0;

  // делаем padding чтобы сдвинуть скролл за видимую границу
  // "виртуальный" скролл также отодвигаем
  const padding = virtualScroll ? SCROLLBAR_OFFSET : scrollbarWidth;

  // делаем отрицательный margin чтобы компенсировать padding
  // когда скролл "физический" (есть полоса прокрутки, как на винде) нужен двойной отрицательный margin
  // чтобы спрятать его на горизонтальном скролле первый компенсирует padding, второй спрячет скролл.
  const margin = -(virtualScroll ? padding : 2 * padding);

  // на вертикальном "физическом" скролле необходимо восстановить ширину на размер скролла
  const size = `calc(100% + ${scrollbarWidth}px)`;

  // при "виртуальном" скролле нужен padding / margin
  // при "физическом" скролле нужен только width xnj,
  const verticalStyle = virtualScroll ? {
    paddingRight: padding,
    marginRight: margin
  } : {
    width: size
  };
  // при горизонтальном скролле выталкивать скролл вниз при помощи height 100% + scrollWidth бесполезно
  // но padding / margin хорошо работает как при "виртуальном", так и при "физическом"
  const horizontalStyle = {
    paddingBottom: padding,
    marginBottom: margin
  };
  return _extends({}, vertical ? verticalStyle : {}, horizontal ? horizontalStyle : {});
};
const createSides = (top, right = top, bottom = top, left = right) => {
  return {
    bottom,
    left,
    right,
    top
  };
};
export const getScrollbarMarginStyles = (direction, margin) => {
  const styleObj = {};
  const dir = direction === 'horizontal' ? 'left' : 'top';
  let style = margin;
  if (typeof style === 'number') {
    style = `${style.toString()}px`;
  }
  if (style) {
    const sides = style.split(' ');
    const [first, ...rest] = sides;
    const styles = createSides(first, ...rest);
    styleObj.bottom = styles.bottom;
    styleObj.right = styles.right;
    styleObj[dir] = styles[dir];
    styleObj.overflow = 'hidden';
  }
  return styleObj;
};